export default __webpack_public_path__ + "static/media/profile-sasan.3719e160.png";